import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Stack } from '@mui/material';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 4, width: '100%', minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box sx={{ maxWidth: 520, textAlign: 'center' }}>
        <Stack direction="column" spacing={3} alignItems="center">
          <ErrorOutlinedIcon sx={{ fontSize: 72, color: 'error.main' }} />
          <Typography variant="h3" sx={{ fontWeight: 700 }}> 
            Page not found
          </Typography>
          <Typography variant="body1" color="text.secondary">
            The page you are looking for does not exist or may have been moved. Use the button below to return to the dashboard.
          </Typography>
          <Button variant="contained" size="large" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default NotFoundPage;
